import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { AccountService } from '@mc/api'
import { AUTH_TYPE } from '@mc/constants'
import { CartEvents } from '@mc/track-event'
import { setCartEmailCookie, setFireEmailCaptureCookie } from '../helpers'

const EMAIL_DOES_NOT_EXIST = 404

export const useEmailCapture = () => {
  const [email, setEmail] = useState('')
  const [isError, setIsError] = useState(false)
  const [isSuccess, setIsSuccess] = useState(false)
  const [isEmailRegistered, setIsEmailRegistered] = useState(false)

  const { isFetching } = useQuery(
    ['checkEmail', email],
    () => AccountService.getRegisteredEmail({ email }),
    {
      enabled: !!email,
      onSuccess: () => {
        // User already exist -- cannot complete flow, they need to sign in.
        setIsEmailRegistered(true)
        setCartEmailCookie(email)
      },
      onError: ({ status }) => {
        // User does not exist -- continue flow
        if (isEmailRegistered) setIsEmailRegistered(false)

        if (status === EMAIL_DOES_NOT_EXIST) {
          setIsSuccess(true)
          setCartEmailCookie(email)
        } else {
          setIsError(true)
        }
      },
      onSettled: () => {
        setFireEmailCaptureCookie({
          authType: AUTH_TYPE.EMAIL,
          captureMethod: CartEvents.EMAIL_GATHER.ADDED_IN_EMAIL_STEP,
        })
      },
    },
  )

  const onCheckEmail = (data: { email: string }) => setEmail(data.email)

  return {
    isLoading: isFetching,
    isError,
    isSuccess,
    isEmailRegistered,
    onCheckEmail,
    email,
  }
}
